import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Row, Col, Input} from 'react-bootstrap'
import {phoneField} from '../../core/phonez'
import Icon from '../../core/components/Icon'
import Card from '../../core/components/Card'
import TypeaheadPatrimonyContactPicker from '../../patrimony/components/TypeaheadContactPicker'
import i18n from '../i18n'

class OpenTicketCallerCard extends Component {
    static propTypes = {
        dispatch: PropTypes.func.isRequired,
        form: PropTypes.func.isRequired,
        cmd: PropTypes.object
    }

    focus = (e) => {
        // focus field to display datalist on (second) click
        e.currentTarget.focus()
    }

    render() {
        const {dispatch, form, cmd, patrimonyQuery, patrimonyStream, ...others} = this.props

        const contactQuery = () => {
            if (cmd && cmd.ticket && cmd.ticket.callerz) {
                return {
                    name: cmd.ticket.callerz.namez,
                    contacts: cmd.ticket.callerz.medium
                }
            }
        }

        const mediumField = (field, type) => {
            const disabled = field.value && field.value.contactMediumType != type || field.disabled
            var value

            switch(type) {
                case 'Phone':
                    value = field.value && field.value.phone
                    break
                case 'Mail':
                    value = field.value && field.value.mail
                    break
                case 'Fax':
                    value = field.value && field.value.fax
                    break
            }

            function onChange(eventOrValue) {
                var value
                if (eventOrValue && eventOrValue.target) {
                    value = eventOrValue.target.value
                } else {
                    value = eventOrValue
                }

                var medium
                switch(type) {
                    case 'Phone':
                        medium = value && {phone: value, contactMediumType: 'Phone'} || null
                        break
                    case 'Mail':
                        medium = value && {mail: value, contactMediumType: 'Mail'} || null
                        break
                    case 'Fax':
                        medium = value && {fax: value, contactMediumType: 'Fax'} || null
                        break
                }

                field.onChange(medium)
            }

            return {...field, disabled, value, onChange}
        }

        const referencedContactCallerField = (field) => {
            const value = field.value && field.value.callerType == 'ReferencedContactCaller' && field.value.uid

            function onChange(contact) {
                const nextValue = contact && {uid: contact, callerType: 'ReferencedContactCaller'} || {callerType: 'HumanCaller'}
                field.onChange(nextValue)
            }

            return {value, onChange}
        }

        const missingField = (field) => {
            if (!field) {
                return {
                    disabled: true,
                    onChange: () => null
                }
            }
            return field
        }

        const header = (
            <h5>{i18n.callerIdentity}</h5>
        )

        const inputAddon = (icon) => (
            <Icon icon={icon} size='xs' />
        )

        return (
            <div>
                <Card
                    kind='tab'
                    header={header}
                    {...others}>
                    <form>
                        <Input
                            type='text'
                            name='company'
                            placeholder={i18n.company}
                            {...missingField(form.ticket.callerz.namez && form.ticket.callerz.namez.company())} />
                        <Row>
                            <Col sm={6}>
                                <Input
                                    type='text'
                                    name='firstName'
                                    placeholder={i18n.firstName + ' *'}
                                    {...missingField(form.ticket.callerz.namez && form.ticket.callerz.namez.firstName())} />
                            </Col>
                            <Col sm={6}>
                                <Input
                                    type='text'
                                    name='lastName'
                                    placeholder={i18n.lastName + ' *'}
                                    {...missingField(form.ticket.callerz.namez && form.ticket.callerz.namez.lastName())} />
                            </Col>
                        </Row>
                        <Input type={"text"}
                               onMouseOver={this.focus}
                               list={"statusz"}
                               maxLength={100}
                               {...missingField(form.ticket.callerz.status && form.ticket.callerz.status())}
                               placeholder={i18n.callerStatus}/>

                        <datalist id={"statusz"}>
                            {i18n.callerStatuses.map(s =><option>{s}</option>)}
                        </datalist>
                        <Input
                            type='text'
                            name='phone'
                            placeholder={i18n.phone}
                            addonBefore={inputAddon('phone')}
                            {...phoneField(mediumField(missingField(form.ticket.callerz.medium && form.ticket.callerz.medium()), 'Phone'))} />
                        <Input
                            type='text'
                            name='email'
                            placeholder={i18n.email}
                            addonBefore={inputAddon('mail')}
                            {...mediumField(missingField(form.ticket.callerz.medium && form.ticket.callerz.medium()), 'Mail')} />
                        <Input
                            type='text'
                            name='fax'
                            placeholder={i18n.fax}
                            addonBefore={inputAddon('fax')}
                            {...phoneField(mediumField(missingField(form.ticket.callerz.medium && form.ticket.callerz.medium()), 'Fax'))} />
                        <Input
                            type='textarea'
                            placeholder={i18n.comment}
                            {...missingField(form.ticket.callerz.comment && form.ticket.callerz.comment())} />
                    </form>
                    {((cmd && cmd.locationRef && cmd.locationRef.patrimonyUid) || (patrimonyQuery && (patrimonyQuery.placeId || patrimonyQuery.geoLocation) && patrimonyStream.length > 0)) && (
                        <TypeaheadPatrimonyContactPicker
                            size='small'
                            patrimonies={cmd && cmd.locationRef && cmd.locationRef.patrimonyUid || patrimonyStream}
                            query={contactQuery()}
                            {...referencedContactCallerField(form.ticket.callerz())} />
                    )}
                </Card>
            </div>
        )
    }
}

OpenTicketCallerCard = connect((state) => ({
    patrimonyQuery: state.patrimony.query,
    patrimonyStream: state.patrimony.stream
}))(OpenTicketCallerCard)

export default OpenTicketCallerCard


// WEBPACK FOOTER //
// ./lib/ticket/components/OpenTicketCallerCard.js